module.exports = __webpack_public_path__ + "img/diy-FzUuGrLi.c3e3a20b.svg";